import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown, Lock, ShieldCheck } from 'lucide-react';
import { Button } from './Button';
export function OfferSection() {
  const faqs = [{
    q: '¿Necesito saber de programación?',
    a: 'No, este manual es sobre habilidades humanas, no sobre código.'
  }, {
    q: '¿Sirve para cualquier industria?',
    a: 'Sí, siempre que tu trabajo implique tomar decisiones o tratar con personas.'
  }, {
    q: '¿Cuánto tiempo me tomará notar cambios?',
    a: 'Los cambios en tu percepción de valor comienzan desde el día 1 con el cambio de comunicación.'
  }, {
    q: '¿Es un curso en video?',
    a: 'No, es un paquete de implementación rápida en PDF y plantillas para que actúes de inmediato.'
  }, {
    q: '¿La IA realmente no puede hacer lo que enseñas?',
    a: 'La IA predice, el ser humano decide. Aquí aprendes a ser el que decide.'
  }];
  const [openFaq, setOpenFaq] = useState<number | null>(0);
  return <section className="py-20 px-4 bg-dark-800 border-t border-gold-500/10" data-id="element-169">
      <div className="max-w-4xl mx-auto" data-id="element-170">
        {/* Proof */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="mb-24 bg-gradient-to-r from-gold-500/10 to-transparent p-8 md:p-12 rounded-2xl border-l-4 border-gold-500" data-id="element-171">
          <p className="text-xl md:text-2xl font-serif text-white italic leading-relaxed" data-id="element-172">
            "En solo 7 días, dejarás de ser un 'ID de usuario' invisible en
            Slack para convertirte en la persona a la que llaman cuando los
            datos no son suficientes. Pasarás de la ansiedad por la
            obsolescencia a la seguridad de quien sabe que su intuición es la
            moneda más cara del mercado actual."
          </p>
        </motion.div>

        {/* FAQ */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="mb-24" data-id="element-173">
          <h2 className="text-3xl font-serif text-white mb-8 text-center" data-id="element-174">
            Preguntas Frecuentes
          </h2>
          <div className="space-y-4" data-id="element-175">
            {faqs.map((faq, index) => <div key={index} className="bg-dark-900 rounded-lg border border-gray-800 overflow-hidden" data-id="element-176">
                <button className="w-full px-6 py-4 text-left flex justify-between items-center focus:outline-none" onClick={() => setOpenFaq(openFaq === index ? null : index)} data-id="element-177">
                  <span className="font-medium text-white" data-id="element-178">{faq.q}</span>
                  <ChevronDown className={`w-5 h-5 text-gold-500 transition-transform ${openFaq === index ? 'rotate-180' : ''}`} data-id="element-179" />
                </button>
                <AnimatePresence data-id="element-180">
                  {openFaq === index && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} className="px-6 pb-4 text-gray-400" data-id="element-181">
                      <p data-id="element-182">{faq.a}</p>
                    </motion.div>}
                </AnimatePresence>
              </div>)}
          </div>
        </motion.div>

        {/* Offer */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} id="offer" className="bg-dark-900 rounded-3xl p-8 md:p-12 border-2 border-gold-500 shadow-[0_0_50px_rgba(201,168,76,0.1)] text-center relative overflow-hidden" data-id="element-183">
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-1 bg-gradient-to-r from-transparent via-gold-500 to-transparent" data-id="element-184"></div>

          <h2 className="text-3xl md:text-4xl font-serif text-white mb-6" data-id="element-185">
            Recupera tu soberanía profesional hoy mismo.
          </h2>
          <p className="text-lg text-gray-300 mb-8 max-w-2xl mx-auto" data-id="element-186">
            Por el precio de un par de cafés, obtén la estrategia completa para
            dejar de temerle al futuro y empezar a liderarlo.
          </p>

          <div className="mb-10" data-id="element-187">
            <span className="text-gray-400 text-sm uppercase tracking-widest block mb-2" data-id="element-188">
              Inversión única
            </span>
            <span className="text-6xl font-serif text-gold-500 font-bold" data-id="element-189">
              $7.97 <span className="text-2xl text-gold-500/70" data-id="element-190">USD</span>
            </span>
          </div>

          <Button href="https://tumentesoberana.com/cart/48610738602203:1" className="w-full md:w-auto text-lg px-12 py-5 mb-6" data-id="element-191">
            RECLAMAR MI BLINDAJE HUMANO AHORA
          </Button>

          <div className="flex flex-col md:flex-row items-center justify-center gap-6 text-sm text-gray-400" data-id="element-192">
            <div className="flex items-center" data-id="element-193">
              <ShieldCheck className="w-5 h-5 text-green-500 mr-2" data-id="element-194" />
              Acceso inmediato tras la compra
            </div>
            <div className="flex items-center" data-id="element-195">
              <Lock className="w-5 h-5 text-gold-500 mr-2" data-id="element-196" />
              Pago seguro y cifrado
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}